import React from 'react';
import './flag.scss';

export const Flag: React.FC<{}> = ({children}) => {
	return <div className="flag-container">{children}</div>;
};
